import React, { useEffect, useState, useCallback } from "react";
import type { MouseEvent } from "react";
import { Link, useNavigate } from "react-router";
import netcapitalLogo from "../../assets/img/brand/netcapitallogo.png";
import { assetUrl } from "../../utils/assetUrl";
import {
  UncontrolledCollapse,
  NavbarBrand,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  DropdownItem,
  Media,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
} from "reactstrap";
import { useAppSelector, useAppDispatch } from "../../services/hooks";
import {
  logoutUser,
  clearCurrentProfile,
} from "../../services/userServices/authActions";

const AuthNavbar = () => {
  const dispatch = useAppDispatch();
  const auth = useAppSelector((s) => s.auth) as any;

  const [name, setName] = useState("");
  const [avatar, setAvatar] = useState("");
  // SCRUM-1887 (same defect as SCRUM-1885): redirect with navigate(), not a
  // `redirect` state rendered as <Navigate>. An instance that survived a quick
  // browser Back still held that state and rendered nothing.
  const navigate = useNavigate();

  useEffect(() => {
    const user = auth?.userconnected?.user;
    if (user) {
      setName(user.name || "");
      setAvatar(user.avatar || "");
    }
  }, [auth]);

  const onLogoutClick = useCallback(
    (e: MouseEvent) => {
      e.preventDefault();
      dispatch(clearCurrentProfile());
      dispatch(logoutUser());
      navigate("/auth/login");
    },
    [dispatch, navigate]
  );

  return (
    <Navbar
      className="navbar-horizontal navbar-main navbar-dark navbar-transparent"
      expand="lg"
      id="navbar-main"
    >
      <Container>
        <NavbarBrand to="/" tag={Link}>
          <img
            alt="..."
            src={assetUrl(netcapitalLogo)}
          />
        </NavbarBrand>
        <button
          aria-controls="navbar-collapse"
          aria-expanded={false}
          aria-label="Toggle navigation"
          className="navbar-toggler"
          data-target="#navbar-collapse"
          data-toggle="collapse"
          id="navbar-collapse"
          type="button"
        >
          <span className="navbar-toggler-icon" />
        </button>

        <UncontrolledCollapse className="navbar-custom-collapse" navbar toggler="#navbar-collapse">
          <div className="navbar-collapse-header">
            <Row>
              <Col className="collapse-brand" xs="6">
                <Link to="/admin/dashboard">
                  <img
                    alt="..."
                    src={assetUrl(netcapitalLogo)}
                  />
                </Link>
              </Col>
              <Col className="collapse-close" xs="6">
                <button
                  aria-controls="navbar-collapse"
                  aria-expanded={false}
                  aria-label="Toggle navigation"
                  className="navbar-toggler"
                  data-target="#navbar-collapse"
                  data-toggle="collapse"
                  id="navbar-collapse"
                  type="button"
                >
                  <span />
                  <span />
                </button>
              </Col>
            </Row>
          </div>

          <Nav className="align-items-center ml-auto ml-md-0" navbar>
            <UncontrolledDropdown nav>
              <DropdownToggle className="nav-link pr-0" color="" tag="a">
                <Media className="align-items-center">
                  <span className="avatar avatar-sm rounded-circle">
                    {avatar ? <img alt="User avatar" src={avatar} /> : null}
                  </span>
                  <Media className="ml-2 d-none d-lg-block">
                    <span className="mb-0 text-sm font-weight-bold">{name}</span>
                  </Media>
                </Media>
              </DropdownToggle>
              <DropdownMenu end>
                <DropdownItem className="noti-title" header tag="div">
                  <h6 className="text-overflow m-0">Welcome!</h6>
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem href="#logout" onClick={onLogoutClick}>
                  <i className="ni ni-user-run" />
                  <span>Logout</span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>

          <hr className="d-lg-none" />
        </UncontrolledCollapse>
      </Container>
    </Navbar>
  );
};

export default AuthNavbar;
